import { defineStore } from "pinia";
import { useDeviceStore } from "@/stores/device";
import { eventBus } from "@/main";
import Vue from "vue";
import dayjs from "dayjs";

let utc = require("dayjs/plugin/utc");

export const useRoutesStore = defineStore("routes", {
  state: () => ({
    version: 1,
    routes: [],
    importedRoute: [],
    bigDataRoute: [],
    generalRoute: {
      data: null,
      excludedZones: [],
      isModified: false,
    },

    weatherSettings: {
      dateOffset: 0,
      timeOffset: 0,
    },

    routeWeather: {
      weatherInWaypoints: [],
    },
    nogoZones: [],
    activeRouteTabInfo: { tabIndex: 0 },
  }),
  // setters: {
  //     setA: (state) => state.routeSettings.draught,
  // },
  getters: {
    getImportedWaypointSpeed: (state) => {
      return (index) => {
        console.log("pp", index);
        let item = state.importedRoute[index]?.["@_speed"] ?? "";
        return item;
        // return this.getShipResponse?.calculatedRouteLegs[index]
      };
    },
    getShipIndex: (state) => {
      const deviceStore = useDeviceStore();
      const deviceID = deviceStore.getDeviceID;
      return state.routes?.findIndex((a) => a?.deviceId === deviceID);
    },
    getShipSettings: (state) => {
      const deviceStore = useDeviceStore();
      const deviceID = deviceStore.getDeviceID;
      return state.routes?.find((a) => a?.deviceId === deviceID)?.routeSettings;
    },
    getShipResponse: (state) => {
      const deviceStore = useDeviceStore();
      const deviceID = deviceStore.getDeviceID;
      return state.routes?.find((a) => a?.deviceId === deviceID)?.routeResponse;
    },
    getShipResponseBackup: (state) => {
      const deviceStore = useDeviceStore();
      const deviceID = deviceStore.getDeviceID;
      return state.routes?.find((a) => a?.deviceId === deviceID)
        ?.routeResponseBackup;
    },
    getRouteName() {
      return this.getShipSettings?.name ?? "";
    },
    getShipNoGo() {
      return Number(this.getShipSettings?.nogo ?? 7);
    },
    getShipDraught() {
      return Number(this.getShipSettings?.draught ?? 5);
    },
    getShipHeight() {
      return Number(this.getShipSettings?.height);
    },
    getShipLength() {
      return Number(this.getShipSettings?.length);
    },
    getShipWidth() {
      return Number(this.getShipSettings?.width);
    },
    getShipDisplacement() {
      return Number(this.getShipSettings?.displacement);
    },
    getShipSpeed() {
      return Number(this.getShipSettings?.speed);
    },
    getShipRadius() {
      return Number(this.getShipSettings?.radius);
    },
    getShipStartDate() {
      return this.getShipSettings?.startdate;
    },
    getShipStartTime() {
      return this.getShipSettings?.starttime;
    },
    getShipXtel() {
      return Number(this.getShipSettings?.xtel);
    },
    getShipXter() {
      return Number(this.getShipSettings?.xter);
    },
    getShipXTE() {
      return (
        Math.max(
          Number(this.getShipSettings?.xtel),
          Number(this.getShipSettings?.xter)
        ) * 2
      );
    },
    getShipTrackratio() {
      return Number(this.getShipSettings?.trackratio);
    },
    getShipShallowratio() {
      return Number(this.getShipSettings?.shallowratio);
    },
    getShipAvoidshallowstrength() {
      return Number(this.getShipSettings?.avoidshallowstrength);
    },
    getShipAvoiddistance() {
      return Number(this.getShipSettings?.avoiddistance);
    },
    getShipUserecommendedtracks() {
      return this.getShipSettings?.userecommendedtracks;
    },
    getShipUsegeneralroutes() {
      return this.getShipSettings?.usegeneralroutes;
    },
    getShipUsesuez() {
      return this.getShipSettings?.usesuez;
    },
    getShipUsepanama() {
      return this.getShipSettings?.usepanama;
    },
    getShipUsebering() {
      return this.getShipSettings?.usebering;
    },
    getShipUserivers() {
      return this.getShipSettings?.userivers;
    },
    getShipRefineCoeffecient() {
      // console.log("rrrr", this.getShipSettings?.refinecoeffecient)
      // console.log("rrrr", Number(this.getShipSettings?.refinecoeffecient))
      return Number(this.getShipSettings?.refinecoefficient ?? "1");
    },
    getShipUseGoodTiles() {
      return this.getShipSettings?.usegoodtiles;
    },
    getShipGraphRouteScoreFactor() {
      return Number(this.getShipSettings?.graphRouteScoreFactor);
    },
    getShipLandAroundScoreFactor() {
      return Number(this.getShipSettings?.landAroundScoreFactor);
    },
    getShipLinkHeuristicFactor() {
      return Number(this.getShipSettings?.linkHeuristicFactor);
    },
    getShipWaterScoreFactor() {
      return Number(this.getShipSettings?.waterScoreFactor);
    },
    getShipNearestPointsNumber() {
      return Number(this.getShipSettings?.nearestPointsNumber);
    },
    getShipPreviewLandContour() {
      return !!this.getShipSettings?.previewLandContour;
    },
    getShipGraphDiag() {
      return !!this.getShipSettings?.graphDiag;
    },
    getShipWaypointsInfo() {
      return this.getShipResponse?.routePointInfos;
    },
    getShipWaypoints() {
      return this.getShipResponse?.calculatedRouteLegs;
    },
    getShipWaypointsCount() {
      return this.getShipResponse?.calculatedRouteLegs.length;
    },
    getShipLeg: (state) => {
      return (index) => {
        const deviceStore = useDeviceStore();
        const deviceID = deviceStore.getDeviceID;
        const resp = state.routes?.find(
          (a) => a?.deviceId === deviceID
        )?.routeResponse;
        return resp?.calculatedRouteLegs[index];
      };
    },
    getShipLegSafety: (state) => {
      return (index) => {
        const deviceStore = useDeviceStore();
        const deviceID = deviceStore.getDeviceID;
        const resp = state.routes?.find(
          (a) => a?.deviceId === deviceID
        )?.routeResponse;
        return resp?.calculatedRouteLegs[index]?.isDepthSafe ?? true;
      };
    },
    getShipLegInfo: (state) => {
      return (index) => {
        const deviceStore = useDeviceStore();
        const deviceID = deviceStore.getDeviceID;
        const resp = state.routes?.find(
          (a) => a?.deviceId === deviceID
        )?.routeResponse;
        return resp?.calculatedRouteLegs[index]?.info;
      };
    },
    getShipLegWarnings: (state) => {
      return (index) => {
        const deviceStore = useDeviceStore();
        const deviceID = deviceStore.getDeviceID;
        const resp = state.routes?.find(
          (a) => a?.deviceId === deviceID
        )?.routeResponse;
        return resp?.calculatedRouteLegs[index]?.overallSafety ?? "safe";
      };
    },
    getShipLegHazards: (state) => {
      return (index) => {
        const deviceStore = useDeviceStore();
        const deviceID = deviceStore.getDeviceID;
        const resp = state.routes?.find(
          (a) => a?.deviceId === deviceID
        )?.routeResponse;
        return resp?.calculatedRouteLegs[index]?.dangerObjects ?? [];
      };
    },
  },
  actions: {
    setActiveRouteTabInfo(value) {
      this.activeRouteTabInfo = value;
    },
    setGeneralRoute(data) {
      this.generalRoute.data = data;
      this.generalRoute.isModified = false;
    },
    setGeneralRouteModified(isModified) {
      this.generalRoute.isModified = isModified;
    },
    setPreviewExcludedZones(excludedZones) {
      this.generalRoute.excludedZones = excludedZones;
    },
    clearGeneralRoute() {
      this.generalRoute.data = null;
      this.generalRoute.excludedZones = [];
    },
    addImportedRoute(points) {
      this.importedRoute = points;
    },
    addShips(installations) {
      dayjs.extend(utc);
      let now = dayjs().utc();
      let date = dayjs(now).format("YYYY-MM-DD");
      let time = dayjs(now).format("HH:mm:ss");

      installations.forEach((installation) => {
        let shipRoute = {
          deviceId: installation.deviceId,
          shipName: installation.shipName,
          routeSettings: {
            name: "",
            nogo: "7",
            draught: "5",
            length: "120",
            width: "20",
            height: "20",
            radius: "120",
            displacement: "8000",
            xtel: "120",
            xter: "120",
            speed: "10",
            trackratio: "0.7",
            shallowratio: "1",
            avoidshallowstrength: "1",
            avoiddistance: "550",
            refinecoefficient: "1",
            startdate: date,
            starttime: time,
            userecommendedtracks: true,
            usegeneralroutes: true,
            usesuez: true,
            usepanama: true,
            usebering: true,
            userivers: false,
            usegoodtiles: true,
            // graph settings
            graphRouteScoreFactor: 0.8,
            landAroundScoreFactor: 1.7,
            waterScoreFactor: 1,
            nearestPointsNumber: 20,
            previewLandContour: false,
            linkHeuristicFactor: 1,
            graphDiag: false,
          },
          routeResponse: {
            routeLength: 0,
            routePoints: [],
            routePointInfos: [],
            dangerObjects: [],
            debugInfo: [],
            restoreRoutePoints: [],
            routeLegs: [],
            calculatedRouteLegs: [],
          },
          routeResponseBackup: {
            startIndex: 0,
            finishIndex: 0,
            isBypass: false,
            routeLength: 0,
            routePoints: [],
            routePointInfos: [],
            dangerObjects: [],
            debugInfo: [],
            restoreRoutePoints: [],
            routeLegs: [],
            calculatedRouteLegs: [],
          },
        };

        // Индекс записи рута для корабля с deviceId
        let shipIndex = this.routes?.findIndex(
          (a) => a?.deviceId === installation.deviceId
        );

        // Если рут для корабля уже существует, не добавляем новую запись
        if (shipIndex === -1) this.routes.push(shipRoute);
      });
    },
    addShipRouteResponse(val, isNeedCheckSafety, updateRouteTable) {
      function findUpdatedElement(arr1, arr2) {
        return arr1.findIndex(
          (element, index) =>
            element?.lat !== arr2[index]?.lat || element.lon !== arr2[index].lon
        );
      }

      if (updateRouteTable) {
        let toggleSafetyCheck = false;
        if (
          this.getShipResponse.calculatedRouteLegs.length !==
          val.calculatedRouteLegs.length
        ) {
          toggleSafetyCheck = true;
        } else {
          this.getShipResponse.calculatedRouteLegs.forEach((item, index) => {
            if (
              item.lat !== val.calculatedRouteLegs[index].lat ||
              item.lon !== val.calculatedRouteLegs[index].lon
            ) {
              toggleSafetyCheck = true;
            }
          });
        }

        if (toggleSafetyCheck) {
          eventBus.$emit("wp-control-toggle-check-safety", true);
        }
      }

      if (this.getShipResponse.routeLength === 0) {
        this.getShipResponse.routeLength = val.routeLength ?? 0;
        this.getShipResponse.calculatedRouteLegs = val.calculatedRouteLegs;
        // this.getShipResponse.routePointInfos = val.routePointInfos
        // this.getShipResponse.dangerObjects = val.dangerObjects ?? []
        // this.getShipResponse.debugInfo = val.debugInfo ?? []
        this.getShipResponse.restoreRoutePoints = val.restoreRoutePoints ?? [];
        // this.getShipResponse.routeLegs = val.routeLegs ?? []
      } else if (this.getShipResponse.routeLength > 0 && updateRouteTable) {
        if (val.routeLength) {
          this.getShipResponse.routeLength = val.routeLength;
        }

        if (
          this.getShipResponse.calculatedRouteLegs.length ===
          val.calculatedRouteLegs.length
        ) {
          // wp was updated
          let index = findUpdatedElement(
            this.getShipResponse.calculatedRouteLegs,
            val.calculatedRouteLegs
          );
          if (index !== -1) {
            this.getShipResponse.calculatedRouteLegs[index].lat =
              val.calculatedRouteLegs[index].lat;
            this.getShipResponse.calculatedRouteLegs[index].lon =
              val.calculatedRouteLegs[index].lon;
            // this.getShipResponse.routeLegs[index].lat = val.calculatedRouteLegs[index].lat
            // this.getShipResponse.routeLegs[index].lon = val.calculatedRouteLegs[index].lon
          }
        } else if (
          this.getShipResponse.calculatedRouteLegs.length >
          val.calculatedRouteLegs.length
        ) {
          // wp was removed
          let index = findUpdatedElement(
            this.getShipResponse.calculatedRouteLegs,
            val.calculatedRouteLegs
          );
          if (index !== -1) {
            this.getShipResponse.calculatedRouteLegs.splice(index, 1);
            // this.getShipResponse.routePointInfos.routeLegs.splice(index, 1)
            // this.getShipResponse.routeLegs.splice(index, 1)
          }
        } else if (
          this.getShipResponse.calculatedRouteLegs.length <
          val.calculatedRouteLegs.length
        ) {
          // wp was added or inserted
          let index = findUpdatedElement(
            val.calculatedRouteLegs,
            this.getShipResponse.calculatedRouteLegs
          );
          this.getShipResponse.calculatedRouteLegs.splice(
            index,
            0,
            val.calculatedRouteLegs[index]
          );
        }
      } else {
        this.getShipResponse.routeLength = val.routeLength ?? 0;
        this.getShipResponse.calculatedRouteLegs = val.calculatedRouteLegs;
        // this.getShipResponse.routePointInfos = val.routePointInfos
        // this.getShipResponse.dangerObjects = val.dangerObjects ?? []
        // this.getShipResponse.debugInfo = val.debugInfo ?? []
        this.getShipResponse.restoreRoutePoints = val.restoreRoutePoints ?? [];
        // this.getShipResponse.routeLegs = val.routeLegs ?? []
      }

      let i = 0;
      this.getShipResponse.calculatedRouteLegs.forEach((item) => {
        item.id = i++;
      });
    },
    resetShipDates() {
      let now = dayjs().utc();
      let date = dayjs(now).format("YYYY-MM-DD");
      let time = dayjs(now).format("HH:mm:ss");

      if (this.getShipSettings) {
        this.getShipSettings.startdate = date;
        this.getShipSettings.starttime = time;
      }
    },
    resetShip() {
      this.getShipResponse.routeLength = 0;
      this.getShipResponse.calculatedRouteLegs = [];
      this.getShipResponse.routePointInfos = [];
      this.getShipResponse.dangerObjects = [];
      this.getShipResponse.debugInfo = [];
      this.getShipResponse.restoreRoutePoints = [];
      this.getShipResponse.routeLegs = [];
      this.getShipResponse.calculatedRouteLegs = [];
      this.resetShipDates()
    },
    backupShipResponse(startIndex, finishIndex) {
      this.getShipResponseBackup.startIndex = startIndex;
      this.getShipResponseBackup.finishIndex = finishIndex;
      this.getShipResponseBackup.isBypass = true;
      this.getShipResponseBackup.routeLength = this.getShipResponse.routeLength;
      this.getShipResponseBackup.calculatedRouteLegs = this.getShipResponse.calculatedRouteLegs;
      // this.getShipResponseBackup.routePointInfos = this.getShipResponse.routePointInfos
      // this.getShipResponseBackup.dangerObjects = this.getShipResponse.dangerObjects
      // this.getShipResponseBackup.debugInfo = this.getShipResponse.debugInfo
      // this.getShipResponseBackup.restoreRoutePoints = this.getShipResponse.restoreRoutePoints
      // this.getShipResponseBackup.routeLegs = this.getShipResponse.routeLegs
    },
    resetShipBypassBackup() {
      if (this.getShipResponseBackup) {
        this.getShipResponseBackup.startIndex = 0;
        this.getShipResponseBackup.finishIndex = 0;
        this.getShipResponseBackup.isBypass = false;
        this.getShipResponseBackup.routeLength = 0;
        this.getShipResponseBackup.calculatedRouteLegs = [];
        this.getShipResponseBackup.routePointInfos = [];
        this.getShipResponseBackup.dangerObjects = [];
        this.getShipResponseBackup.debugInfo = [];
        this.getShipResponseBackup.restoreRoutePoints = [];
        this.getShipResponseBackup.routeLegs = [];
      }
    },

    restoreShipRouteSettings(val) {
      const deviceStore = useDeviceStore();
      const deviceID = deviceStore.getDeviceID;
      this.routes.find((a) => a?.deviceId === deviceID).routeSettings = val;

      // this.getShipSettings = val
    },
    restoreShipRouteResponse(val) {
      const deviceStore = useDeviceStore();
      const deviceID = deviceStore.getDeviceID;
      this.routes.find((a) => a?.deviceId === deviceID).routeResponse = val;

      // this.getShipResponse = val
    },
    initWeather(count) {
      this.routeWeather.weatherInWaypoints = Array.from(
        { length: count },
        () => ({
          temperature: "N/A",
          wind: "N/A",
          windAngle: "N/A",
        })
      );
    },
    addWeather(val, index) {
      Vue.set(this.routeWeather.weatherInWaypoints, index, val);
    },
    // Пакетное обновление погоды
    setWeatherBatch(weatherData) {
      this.routeWeather.weatherInWaypoints = weatherData;
    },
    addBigDataRoute(val) {
      this.bigDataRoute = val;
    },
    clearBigDataRoute() {
      this.bigDataRoute = [];
    },
    addRouteLegs(val) {
      this.routeLegs = val;
    },
    addNoGoZone(val) {
      this.nogoZones = val;
    },
    deleteNoGoZone(val) {
      let index = this.nogoZones.findIndex((p) => p.name == val);
      this.nogoZones.splice(index, 1);
    },
    addWeatherSettings(dateOffset, timeOffset) {
      this.weatherSettings.dateOffset = dateOffset;
      this.weatherSettings.timeOffset = timeOffset;
    },
  },
  persist: true,
});
